
namespace Matrix.Workflow {

    @Serenity.Decorators.registerClass()
    export class TaskGrid extends SiteEntityGrid<TaskRow, any> {
        protected getColumnsKey() { return 'Workflow.Task'; }
        protected getDialogType() { return TaskDialog; }
        protected getIdProperty() { return TaskRow.idProperty; }
        protected getLocalTextPrefix() { return TaskRow.localTextPrefix; }
        protected getService() { return TaskService.baseUrl; }

        constructor(container: JQuery) {
            super(container);
        }
    }
}